import React from 'react';
import { motion } from 'framer-motion';
import { Heart, DollarSign, BookOpen, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Heart,
  title: 'Aprendé algo lindo y útil',
  desc: 'Descubrí una actividad creativa, relajante y llena de posibilidades para hacer con tus propias manos.'
}, {
  icon: DollarSign,
  title: 'Generá ingresos extra desde casa',
  desc: 'Convertí tus creaciones en regalos, souvenirs o productos personalizados para vender.'
}, {
  icon: BookOpen,
  title: 'Empezá aunque no tengas experiencia',
  desc: 'El kit está pensado para acompañarte paso a paso, de forma simple, visual y ordenada.'
}, {
  icon: Sparkles,
  title: 'Creá detalles que enamoran',
  desc: 'Nombres, flores, decoraciones y piezas únicas para cumpleaños, eventos y momentos especiales.'
}];
export function Benefits() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-15">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-16">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl text-brand-text mb-6" data-id="element-17">
          ¿Sentís que es momento de crear algo propio?
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-18">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-brand-card rounded-3xl p-8 shadow-sm border border-brand-accent/10 hover:shadow-md transition-shadow" data-id="element-19">
            <div className="w-14 h-14 rounded-2xl bg-brand-alt-bg flex items-center justify-center mb-6 text-brand-cta" data-id="element-20">
              <benefit.icon size={28} strokeWidth={1.5} data-id="element-21" />
            </div>
            <h3 className="text-xl mb-3 text-brand-text font-semibold font-sans" data-id="element-22">
              {benefit.title}
            </h3>
            <p className="text-brand-text/70 leading-relaxed" data-id="element-23">{benefit.desc}</p>
          </motion.div>)}
      </div>
    </section>;
}